import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  useTheme,
} from '@material-ui/core';
import { ChangeEvent } from 'react';

export type IMultiSelectCheckbox = Iprops<TmenuItem>;

interface Iprops<T> {
  items: T[];
  defaultValue: string[];
  handleSelected: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    selectedItem: T
  ) => void;
  onChecked: (item: T) => boolean;
  placeholder: string;
  renderValue: React.ReactNode;
  id?: string;
  icon?: React.ReactNode;
}

export type TmenuItem = {
  key: string;
  name: string;
  id?: string;
};

const MultiSelectCheckbox: React.FC<IMultiSelectCheckbox> = ({
  items,
  defaultValue,
  handleSelected,
  onChecked,
  placeholder,
  renderValue,
  id,
  icon,
}) => {
  const theme = useTheme();
  const sxLabel = {
    display: 'flex',
    gridGap: 3,
    alignItems: 'center',
    bgcolor: theme.palette.background.paper,
    paddingX: '5px',
  };

  return (
  <FormControl variant="outlined" fullWidth disabled={items.length === 1}>
    <InputLabel
      htmlFor={`label-${id || placeholder}`}
      style={{ top: icon ? '-3.5px' : 0 }}
    >
      {icon ? (
        <Box sx={sxLabel}>
          {icon}
          {placeholder}
        </Box>
      ) : (
        placeholder
      )}
    </InputLabel>
    <Select
      id={`select-${id || placeholder}`}
      multiple
      value={defaultValue}
      label={placeholder}
      labelId={`label-${id || placeholder}`}
      renderValue={() => renderValue}
      MenuProps={{ style: { maxHeight: '350px' } }}
    >
      {items.map((item, index) => (
        <MenuItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${item.key}-${index}`}
          component="li"
        >
          <Checkbox
            checked={onChecked(item)}
            onChange={(event, checked) => {
              handleSelected(event, checked, item);
            }}
          />
          <ListItemText primary={item.name} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
  );
};

export default MultiSelectCheckbox;
